
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_l0dv0_1v1kc_97",
  "header": "awsui_header_l0dv0_1v1kc_134",
  "with-toolbar": "awsui_with-toolbar_l0dv0_1v1kc_146",
  "header-link": "awsui_header-link_l0dv0_1v1kc_150",
  "header-link--has-logo": "awsui_header-link--has-logo_l0dv0_1v1kc_160",
  "header-link-text": "awsui_header-link-text_l0dv0_1v1kc_160",
  "header-logo": "awsui_header-logo_l0dv0_1v1kc_165",
  "header-logo--stretched": "awsui_header-logo--stretched_l0dv0_1v1kc_171",
  "list-container": "awsui_list-container_l0dv0_1v1kc_176",
  "list": "awsui_list_l0dv0_1v1kc_176",
  "list-variant-root": "awsui_list-variant-root_l0dv0_1v1kc_191",
  "list-variant-root--last": "awsui_list-variant-root--last_l0dv0_1v1kc_198",
  "list-variant-expandable-link-group": "awsui_list-variant-expandable-link-group_l0dv0_1v1kc_202",
  "list-item": "awsui_list-item_l0dv0_1v1kc_206",
  "section": "awsui_section_l0dv0_1v1kc_214",
  "expandable-link-group": "awsui_expandable-link-group_l0dv0_1v1kc_215",
  "section--no-ident": "awsui_section--no-ident_l0dv0_1v1kc_218",
  "expandable-link-group--no-ident": "awsui_expandable-link-group--no-ident_l0dv0_1v1kc_219",
  "refresh": "awsui_refresh_l0dv0_1v1kc_227",
  "list-variant-section-group": "awsui_list-variant-section-group_l0dv0_1v1kc_235",
  "section-group": "awsui_section-group_l0dv0_1v1kc_242",
  "section-group-title": "awsui_section-group-title_l0dv0_1v1kc_253",
  "link": "awsui_link_l0dv0_1v1kc_257",
  "link-active": "awsui_link-active_l0dv0_1v1kc_266",
  "info": "awsui_info_l0dv0_1v1kc_303",
  "external-icon": "awsui_external-icon_l0dv0_1v1kc_307",
  "divider": "awsui_divider_l0dv0_1v1kc_311",
  "divider-default": "awsui_divider-default_l0dv0_1v1kc_316",
  "divider-header": "awsui_divider-header_l0dv0_1v1kc_322"
};
  